import { lazy } from "react";

export const MyRoomsPageAsync = lazy(() => import("./MyRoomsPage").then((module) => ({ default: module.MyRoomsPage })));
